export const PurchaseJourneyConstants = {
  DEBIT_CARD_PRODUCT_ID: 'tyme-debit-card',
  DELIVERY_SAME_AS_BILLING: 'same',
  DELIVERY_DIFFERENT_FROM_BILLING: 'different',
};
